<template>
  <div :class="`${ns.b('group')}`">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, provide, reactive, toRef } from 'vue'
import { useNamespace } from '@sgui-plus/hooks'
import { ButtonGroupContextKey } from './constants'
import { buttonGroupProps } from './button-group'

export default defineComponent({
  name: 'SgButtonGroup',
  props: buttonGroupProps,

  setup(props) {
    provide(
      ButtonGroupContextKey,
      reactive({
        size: toRef(props, 'size'),
        type: toRef(props, 'type'),
      })
    )
    const ns = useNamespace('button')
    return {
      ns,
    }
  },
})
</script>
